import React, { useState, useEffect, useRef } from "react";
import {
	InputContainer,
	SearchContainer,
	Dropdown,
	DropdownItem
} from "./styles";

export function SearchInput({
	label,
	value,
	onChange,
	onSearch,
	options = [],
	placeholder,
	loading = false,
	error,
	...props
}) {
	const [inputValue, setInputValue] = useState("");
	const [showDropdown, setShowDropdown] = useState(false);
	const [selectedOption, setSelectedOption] = useState(null);
	const dropdownRef = useRef(null);
	const inputRef = useRef(null);

	useEffect(() => {
		if (value && typeof value === "object" && value.label) {
			setInputValue(value.label);
			setSelectedOption(value);
		} else if (value && typeof value === "string") {
			setInputValue(value);
		}
	}, [value]);

	useEffect(() => {
		const handleClickOutside = event => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setShowDropdown(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleInputChange = e => {
		const newValue = e.target.value;
		setInputValue(newValue);
		setSelectedOption(null);
		setShowDropdown(true);

		if (onChange) {
			onChange(null);
		}

		if (onSearch) {
			onSearch(newValue);
		}
	};

	const handleOptionSelect = option => {
		setInputValue(option.label);
		setSelectedOption(option);
		setShowDropdown(false);

		if (onChange) {
			onChange(option);
		}
	};

	const handleInputFocus = () => {
		setShowDropdown(true);
	};

	const handleInputBlur = () => {
		setTimeout(() => {
			// Se não há seleção válida, limpar o campo
			if (!selectedOption) {
				setInputValue("");
				if (onChange) {
					onChange(null);
				}
			}
		}, 150);
	};

	return (
		<InputContainer>
			<label htmlFor={label}>{label}</label>
			<SearchContainer ref={dropdownRef}>
				<input
					ref={inputRef}
					type="text"
					id={label}
					value={inputValue}
					onChange={handleInputChange}
					onFocus={handleInputFocus}
					onBlur={handleInputBlur}
					placeholder={placeholder}
					autoComplete="off"
					{...props}
				/>
				{showDropdown && (
					<Dropdown>
						{loading ? (
							<DropdownItem>Carregando...</DropdownItem>
						) : (
							options.map((option, index) => (
								<DropdownItem
									key={option.value || index}
									onMouseDown={e => {
										e.preventDefault();
										handleOptionSelect(option);
									}}
								>
									{option.label}
								</DropdownItem>
							))
						)}
					</Dropdown>
				)}
			</SearchContainer>
			{error && <span className="form__form-group-error">{error}</span>}
		</InputContainer>
	);
}
